import React from 'react';
import {motion} from 'framer-motion';
import {useLanguage} from '../context/LanguageContext';
import CosmoHeads from './CosmoHeads';

// Component that displays the three COSMO heads with explanation
const CosmoAttentionLevels=()=> {
  const {t}=useLanguage();

  const container={
    hidden: {opacity: 0},
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3
      }
    }
  };

  const item={
    hidden: {opacity: 0,y: 20},
    show: {opacity: 1,y: 0}
  };

  return (
    <div className="bg-white rounded-xl shadow-lg p-6 mb-8">
      <div className="text-center mb-6">
        <h3 className="text-2xl font-bold text-gray-900 mb-2">{t('cosmoOrients')}</h3>
        <p className="text-gray-600">{t('attentionLevelsExplanation')}</p>
      </div>

      <motion.div 
        className="grid grid-cols-1 md:grid-cols-3 gap-6"
        variants={container}
        initial="hidden"
        animate="show"
      >
        <motion.div 
          variants={item}
          className="flex flex-col items-center bg-green-50 rounded-lg p-6"
        >
          <CosmoHeads attentionLevel="normal" size="large" showLabel={false} />
          <div className="mt-4 text-center">
            <h4 className="font-semibold text-green-700">Normal</h4>
            <p className="text-sm text-gray-600 mt-2">
              Scores within normal range that don't require specific clinical attention
            </p>
          </div>
        </motion.div>

        <motion.div 
          variants={item}
          className="flex flex-col items-center bg-yellow-50 rounded-lg p-6"
        >
          <CosmoHeads attentionLevel="attention" size="large" showLabel={false} />
          <div className="mt-4 text-center">
            <h4 className="font-semibold text-yellow-700">Clinical Attention</h4>
            <p className="text-sm text-gray-600 mt-2">
              Scores that require clinical attention and monitoring
            </p>
          </div>
        </motion.div>

        <motion.div 
          variants={item}
          className="flex flex-col items-center bg-red-50 rounded-lg p-6"
        >
          <CosmoHeads attentionLevel="highAttention" size="large" animate={true} showLabel={false} />
          <div className="mt-4 text-center">
            <h4 className="font-semibold text-red-700">High Clinical Attention</h4>
            <p className="text-sm text-gray-600 mt-2">
              Scores that require immediate clinical attention and intervention
            </p>
          </div>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default CosmoAttentionLevels;